import React from "react";
import { Form, InputNumber } from "antd";
import { get } from 'lodash';

// const handleLeftRightKey = (e) => {
//   //console.log('test:', e.key.toLowerCase());
//   const form = e.target.form;
//   const index = [...form].indexOf(e.target);
//   if (e.key.toLowerCase() === "arrowright") {
//     form.elements[index + 1].focus();
//   }
//   if (e.key.toLowerCase() === "arrowleft") {
//     form.elements[index - 1].focus();
//   }
// }

const NumberInput = ({
  values,
  errors,
  handleSubmit,
  setFieldValue,
  setFieldTouched,
  name,
  label,
  formItemLayout,
  placeholder,
  readOnly,
  formatter,
  parser,
  min,
  max,
  step,
  formattype,
  size,
  autoFocus
}) => {

  let _formatter;
  let _parser;
  let _decimalSeparator = ','
  // let val = get(values, name);
  switch (formattype) {
    // Werkt niet als er gedeployed is..., lokaal wel...
    case "valuta":
      _formatter = value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      _parser = value => value.replace(/(\.*)/g, '');
      _decimalSeparator = null;
      break;
    default:
      _formatter = formatter;
      _parser = parser;
      break;
  }

  return (
    <Form.Item label={label} {...formItemLayout}
      hasFeedback={!!get(errors, name)}
      validateStatus={get(errors, name) && "error"}
      help={get(errors, name)}
    >
      <InputNumber
        // onKeyDown={handleLeftRightKey}
        autoFocus={autoFocus ? autoFocus : false}
        size={size}
        placeholder={placeholder}
        value={get(values, name)}
        onChange={value => setFieldValue(name, value)}
        onBlur={() => setFieldTouched(name)}
        //onPressEnter={handleSubmit}
        readOnly={readOnly}
        formatter={_formatter}
        parser={_parser}
        min={min}
        max={max}
        step={step}
        decimalSeparator={_decimalSeparator}
      />
    </Form.Item>
  )
};

export default NumberInput;
